import script from "./UsageStatsChart.vue?vue&type=script&lang=js"
export * from "./UsageStatsChart.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__